// @flow

import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { getPlaceholder } from 'utils/assetsUtils';
import { Link } from 'react-router-dom';
import BackgroundImage from 'components/fragments/BackgroundImage';
import { handleTagEvent } from 'utils/tagManagerUtils';
import type { FullUserType } from 'types/User';

export type StateProps = {
  userPref: FullUserType,
};

type Props = StateProps & {
  url: string,
  backgroundUrl?: Object,
  title: string,
  linkLabel: string,
  desc?: string,
  isCompact?: boolean
};

class CardThumbnail extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    isCompact: false,
    backgroundUrl: {
      src: '',
      legend: '',
      sizes: {}
    },
    title: '',
    linkLabel: ''
  };

  render() {
    const { userPref, url, isCompact, title, desc, linkLabel, backgroundUrl } = this.props;
    const classNamesCard = dynamicClassName('box card card--hub-alt');
    isCompact && classNamesCard.add('card--compact');

    return (
      <Link
        to={url}
        className={classNamesCard.build()}
        onClick={handleTagEvent(
          'module contenu',
          title,
          window.location.pathname,
          userPref
        )}
      >
        <BackgroundImage
          className="card__thumbnail img-blue-dark"
          illustration={backgroundUrl ? backgroundUrl.src : getPlaceholder()}
          srcset={backgroundUrl && backgroundUrl.sizes}
        />
        <div className="card__body">
          <h3 className="card__title">{title}</h3>
          {!isCompact && desc && <p className="card__desc ft-secondary">{desc}</p>}
        </div>
        <div className="card__footer">
          <span className="btn btn--cheer">
            <i className="icon icon-chevron-right link-icon is-dark is-inline" />
            {linkLabel}
          </span>
        </div>
      </Link>
    );
  }
}

export default CardThumbnail;
